function createApi(__exports) {
    let wasm;

    const heap = new Array(32).fill(undefined);

    heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachegetFloat64Memory0 = null;
function getFloat64Memory0() {
    if (cachegetFloat64Memory0 === null || cachegetFloat64Memory0.buffer !== wasm.memory.buffer) {
        cachegetFloat64Memory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachegetFloat64Memory0;
}

let cachegetInt32Memory0 = null;
function getInt32Memory0() {
    if (cachegetInt32Memory0 === null || cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
        cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachegetInt32Memory0;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}
/**
* increment reference count
* @param {number} distances
* @returns {number}
*/
__exports.distances_retain = function(distances) {
    var ret = wasm.distances_retain(distances);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} distances
* @returns {number}
*/
__exports.distances_release = function(distances) {
    var ret = wasm.distances_release(distances);
    return ret >>> 0;
};

/**
* get count of distanceses
* @param {number} distances
* @returns {number}
*/
__exports.distances_size = function(distances) {
    var ret = wasm.distances_size(distances);
    return ret >>> 0;
};

/**
* get distance at index
* @param {number} distances
* @param {number} idx
* @returns {number}
*/
__exports.distances_get = function(distances, idx) {
    var ret = wasm.distances_get(distances, idx);
    return ret;
};

let WASM_VECTOR_LEN = 0;

function passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8);
    getFloat64Memory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
* create matrix
* @param {Float64Array} components
* @returns {number}
*/
__exports.matrix_create_with_components_row_order = function(components) {
    var ptr0 = passArrayF64ToWasm0(components, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    var ret = wasm.matrix_create_with_components_row_order(ptr0, len0);
    return ret;
};

/**
* create matrix
* @param {Float64Array} components
* @returns {number}
*/
__exports.matrix_create_with_components_col_order = function(components) {
    var ptr0 = passArrayF64ToWasm0(components, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    var ret = wasm.matrix_create_with_components_col_order(ptr0, len0);
    return ret;
};

/**
* create matrix
* @param {number} dim
* @returns {number}
*/
__exports.matrix_create_with_dimension = function(dim) {
    var ret = wasm.matrix_create_with_dimension(dim);
    return ret;
};

/**
* increment reference count
* @param {number} mat
* @returns {number}
*/
__exports.matrix_retain = function(mat) {
    var ret = wasm.matrix_retain(mat);
    return ret >>> 0;
};

/**
* increment reference count
* @param {number} mat
* @returns {number}
*/
__exports.matrix_release = function(mat) {
    var ret = wasm.matrix_release(mat);
    return ret >>> 0;
};

/**
* components as array
* @param {number} mat
* @returns {Float64Array | undefined}
*/
__exports.matrix_get_components_col_order = function(mat) {
    var ret = wasm.matrix_get_components_col_order(mat);
    return takeObject(ret);
};

/**
* components as array
* @param {number} mat
* @returns {Float32Array | undefined}
*/
__exports.matrix_get_components_col_order_32 = function(mat) {
    var ret = wasm.matrix_get_components_col_order_32(mat);
    return takeObject(ret);
};

/**
* components as array
* @param {number} mat
* @returns {Float64Array | undefined}
*/
__exports.matrix_get_components_row_order = function(mat) {
    var ret = wasm.matrix_get_components_row_order(mat);
    return takeObject(ret);
};

/**
* components as array
* @param {number} mat
* @returns {Float32Array | undefined}
*/
__exports.matrix_get_components_row_order_32 = function(mat) {
    var ret = wasm.matrix_get_components_row_order_32(mat);
    return takeObject(ret);
};

/**
* mutiply two matrices
* @param {number} mat1
* @param {number} mat2
* @returns {boolean | undefined}
*/
__exports.matrix_multiply_mut = function(mat1, mat2) {
    var ret = wasm.matrix_multiply_mut(mat1, mat2);
    return ret === 0xFFFFFF ? undefined : ret !== 0;
};

/**
* mutiply two matrices
* @param {number} mat1
* @param {number} mat2
* @returns {number}
*/
__exports.matrix_multiply = function(mat1, mat2) {
    var ret = wasm.matrix_multiply(mat1, mat2);
    return ret;
};

/**
* calculate inverse matrix
* @param {number} mat
* @returns {number}
*/
__exports.matrix_inverse = function(mat) {
    var ret = wasm.matrix_inverse(mat);
    return ret;
};

/**
* multiply each compoents of matrix with scale
* @param {number} mat
* @param {number} scale
* @returns {boolean}
*/
__exports.matrix_scale_mut = function(mat, scale) {
    var ret = wasm.matrix_scale_mut(mat, scale);
    return ret !== 0;
};

/**
* multiply each components of matrix with scale
* @param {number} mat
* @param {number} scale
* @returns {number}
*/
__exports.matrix_scale = function(mat, scale) {
    var ret = wasm.matrix_scale(mat, scale);
    return ret;
};

/**
* apply vector to left side matrix
* @param {number} mat
* @param {number} v
* @returns {number}
*/
__exports.matrix_apply_l_with_vec = function(mat, v) {
    var ret = wasm.matrix_apply_l_with_vec(mat, v);
    return ret;
};

/**
* apply vector to right side matrix
* @param {number} mat
* @param {number} v
* @returns {number}
*/
__exports.matrix_apply_r_with_vec = function(mat, v) {
    var ret = wasm.matrix_apply_r_with_vec(mat, v);
    return ret;
};

/**
* apply vector to left side matrix
* @param {number} mat
* @param {Float64Array} v
* @returns {Float64Array | undefined}
*/
__exports.matrix_apply_l_64 = function(mat, v) {
    var ret = wasm.matrix_apply_l_64(mat, addHeapObject(v));
    return takeObject(ret);
};

/**
* apply vector to left side matrix
* @param {number} mat
* @param {Float32Array} v
* @returns {Float32Array | undefined}
*/
__exports.matrix_apply_l_32 = function(mat, v) {
    var ret = wasm.matrix_apply_l_32(mat, addHeapObject(v));
    return takeObject(ret);
};

/**
* apply vector to right side matrix
* @param {number} mat
* @param {Float64Array} v
* @returns {Float64Array | undefined}
*/
__exports.matrix_apply_r_64 = function(mat, v) {
    var ret = wasm.matrix_apply_r_64(mat, addHeapObject(v));
    return takeObject(ret);
};

/**
* apply vector to right side matrix
* @param {number} mat
* @param {Float32Array} v
* @returns {Float32Array | undefined}
*/
__exports.matrix_apply_r_32 = function(mat, v) {
    var ret = wasm.matrix_apply_r_32(mat, addHeapObject(v));
    return takeObject(ret);
};

/**
* create cross product matrix
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {number}
*/
__exports.matrix_new_cross_product = function(x, y, z) {
    var ret = wasm.matrix_new_cross_product(x, y, z);
    return ret;
};

/**
* create axis rotation matrix
* @param {number} theta
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {number}
*/
__exports.matrix_new_axis_rotation = function(theta, x, y, z) {
    var ret = wasm.matrix_new_axis_rotation(theta, x, y, z);
    return ret;
};

/**
* apply rotatation matrix
* @param {number} mat
* @param {number} theta
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {boolean}
*/
__exports.matrix_rotate_mut = function(mat, theta, x, y, z) {
    var ret = wasm.matrix_rotate_mut(mat, theta, x, y, z);
    return ret !== 0;
};

/**
* apply rotatation matrix
* @param {number} mat
* @param {number} theta
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {number}
*/
__exports.matrix_rotate = function(mat, theta, x, y, z) {
    var ret = wasm.matrix_rotate(mat, theta, x, y, z);
    return ret;
};

/**
* apply rotatation matrix
* @param {number} mat
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {boolean}
*/
__exports.matrix_translate_mut = function(mat, x, y, z) {
    var ret = wasm.matrix_translate_mut(mat, x, y, z);
    return ret !== 0;
};

/**
* apply translate matrix
* @param {number} mat
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {number}
*/
__exports.matrix_translate = function(mat, x, y, z) {
    var ret = wasm.matrix_translate(mat, x, y, z);
    return ret;
};

/**
* apply scale matrix
* @param {number} mat
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {boolean}
*/
__exports.matrix_scale3_mut = function(mat, x, y, z) {
    var ret = wasm.matrix_scale3_mut(mat, x, y, z);
    return ret !== 0;
};

/**
* apply scale matrix
* @param {number} mat
* @param {number} x
* @param {number} y
* @param {number} z
* @returns {number}
*/
__exports.matrix_scale3 = function(mat, x, y, z) {
    var ret = wasm.matrix_scale3(mat, x, y, z);
    return ret;
};

/**
* create frustum matrix
* @param {number} left
* @param {number} right
* @param {number} bottom
* @param {number} top
* @param {number} near
* @param {number} far
* @returns {number}
*/
__exports.matrix_new_flustum = function(left, right, bottom, top, near, far) {
    var ret = wasm.matrix_new_flustum(left, right, bottom, top, near, far);
    return ret;
};

/**
* apply frustum matrix
* @param {number} mat
* @param {number} left
* @param {number} right
* @param {number} bottom
* @param {number} top
* @param {number} near
* @param {number} far
* @returns {boolean}
*/
__exports.matrix_frustum_mut = function(mat, left, right, bottom, top, near, far) {
    var ret = wasm.matrix_frustum_mut(mat, left, right, bottom, top, near, far);
    return ret !== 0;
};

/**
* apply frustum matrix
* @param {number} mat
* @param {number} left
* @param {number} right
* @param {number} bottom
* @param {number} top
* @param {number} near
* @param {number} far
* @returns {number}
*/
__exports.matrix_frustum = function(mat, left, right, bottom, top, near, far) {
    var ret = wasm.matrix_frustum(mat, left, right, bottom, top, near, far);
    return ret;
};

/**
* create ortho matrix
* @param {number} left
* @param {number} right
* @param {number} bottom
* @param {number} top
* @param {number} near
* @param {number} far
* @returns {number}
*/
__exports.matrix_new_ortho = function(left, right, bottom, top, near, far) {
    var ret = wasm.matrix_new_ortho(left, right, bottom, top, near, far);
    return ret;
};

/**
* apply ortho  matrix
* @param {number} mat
* @param {number} left
* @param {number} right
* @param {number} bottom
* @param {number} top
* @param {number} near
* @param {number} far
* @returns {boolean}
*/
__exports.matrix_ortho_mut = function(mat, left, right, bottom, top, near, far) {
    var ret = wasm.matrix_ortho_mut(mat, left, right, bottom, top, near, far);
    return ret !== 0;
};

/**
* apply ortho matrix
* @param {number} mat
* @param {number} left
* @param {number} right
* @param {number} bottom
* @param {number} top
* @param {number} near
* @param {number} far
* @returns {number}
*/
__exports.matrix_ortho = function(mat, left, right, bottom, top, near, far) {
    var ret = wasm.matrix_ortho(mat, left, right, bottom, top, near, far);
    return ret;
};

/**
* create perspective matrix
* @param {number} fovy
* @param {number} aspect
* @param {number} z_near
* @param {number} z_far
* @returns {number}
*/
__exports.matrix_new_perspective = function(fovy, aspect, z_near, z_far) {
    var ret = wasm.matrix_new_perspective(fovy, aspect, z_near, z_far);
    return ret;
};

/**
* apply perspective  matrix
* @param {number} mat
* @param {number} fovy
* @param {number} aspect
* @param {number} z_near
* @param {number} z_far
* @returns {boolean}
*/
__exports.matrix_perspective_mut = function(mat, fovy, aspect, z_near, z_far) {
    var ret = wasm.matrix_perspective_mut(mat, fovy, aspect, z_near, z_far);
    return ret !== 0;
};

/**
* apply perspective matrix
* @param {number} mat
* @param {number} fovy
* @param {number} aspect
* @param {number} z_near
* @param {number} z_far
* @returns {number}
*/
__exports.matrix_perspective = function(mat, fovy, aspect, z_near, z_far) {
    var ret = wasm.matrix_perspective(mat, fovy, aspect, z_near, z_far);
    return ret;
};

/**
* create look at matrix
* @param {number} eye_x
* @param {number} eye_y
* @param {number} eye_z
* @param {number} center_x
* @param {number} center_y
* @param {number} center_z
* @param {number} up_x
* @param {number} up_y
* @param {number} up_z
* @returns {number}
*/
__exports.matrix_new_look_at = function(eye_x, eye_y, eye_z, center_x, center_y, center_z, up_x, up_y, up_z) {
    var ret = wasm.matrix_new_look_at(eye_x, eye_y, eye_z, center_x, center_y, center_z, up_x, up_y, up_z);
    return ret;
};

/**
* apply look at matrix
* @param {number} mat
* @param {number} eye_x
* @param {number} eye_y
* @param {number} eye_z
* @param {number} center_x
* @param {number} center_y
* @param {number} center_z
* @param {number} up_x
* @param {number} up_y
* @param {number} up_z
* @returns {boolean}
*/
__exports.matrix_look_at_mut = function(mat, eye_x, eye_y, eye_z, center_x, center_y, center_z, up_x, up_y, up_z) {
    var ret = wasm.matrix_look_at_mut(mat, eye_x, eye_y, eye_z, center_x, center_y, center_z, up_x, up_y, up_z);
    return ret !== 0;
};

/**
* apply perspective matrix
* @param {number} mat
* @param {number} eye_x
* @param {number} eye_y
* @param {number} eye_z
* @param {number} center_x
* @param {number} center_y
* @param {number} center_z
* @param {number} up_x
* @param {number} up_y
* @param {number} up_z
* @returns {number}
*/
__exports.matrix_look_at = function(mat, eye_x, eye_y, eye_z, center_x, center_y, center_z, up_x, up_y, up_z) {
    var ret = wasm.matrix_look_at(mat, eye_x, eye_y, eye_z, center_x, center_y, center_z, up_x, up_y, up_z);
    return ret;
};

/**
* increment reference count
* @param {number} seg
* @returns {number}
*/
__exports.segment_retain = function(seg) {
    var ret = wasm.segment_retain(seg);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} seg
* @returns {number}
*/
__exports.segment_release = function(seg) {
    var ret = wasm.segment_release(seg);
    return ret >>> 0;
};

/**
* create segment
* @param {number} d
* @param {number} c
* @param {number} t0
* @param {number} t1
* @returns {number}
*/
__exports.segment_create_00 = function(d, c, t0, t1) {
    var ret = wasm.segment_create_00(d, c, t0, t1);
    return ret;
};

/**
* create segment instance
* @param {Float64Array} d
* @param {Float64Array} c
* @param {number} t0
* @param {number} t1
* @returns {number}
*/
__exports.segment_create_01 = function(d, c, t0, t1) {
    var ret = wasm.segment_create_01(addHeapObject(d), addHeapObject(c), t0, t1);
    return ret;
};

/**
* create segment
* @param {number} p1
* @param {number} p2
* @returns {number}
*/
__exports.segment_create_10 = function(p1, p2) {
    var ret = wasm.segment_create_10(p1, p2);
    return ret;
};

/**
* create segment instance
* @param {Float64Array} p1
* @param {Float64Array} p2
* @returns {number}
*/
__exports.segment_create_11 = function(p1, p2) {
    var ret = wasm.segment_create_11(addHeapObject(p1), addHeapObject(p2));
    return ret;
};

/**
* p1 vector
* @param {number} seg
* @returns {number}
*/
__exports.segment_p1_0 = function(seg) {
    var ret = wasm.segment_p1_0(seg);
    return ret;
};

/**
* p1 vector
* @param {number} seg
* @returns {Float64Array | undefined}
*/
__exports.segment_p1 = function(seg) {
    var ret = wasm.segment_p1(seg);
    return takeObject(ret);
};

/**
* p2 vector
* @param {number} seg
* @returns {number}
*/
__exports.segment_p2_0 = function(seg) {
    var ret = wasm.segment_p2_0(seg);
    return ret;
};

/**
* p2 vector
* @param {number} seg
* @returns {Float64Array | undefined}
*/
__exports.segment_p2 = function(seg) {
    var ret = wasm.segment_p2(seg);
    return takeObject(ret);
};

/**
* direction
* @param {number} seg
* @returns {number}
*/
__exports.segment_direction_0 = function(seg) {
    var ret = wasm.segment_direction_0(seg);
    return ret;
};

/**
* direction
* @param {number} seg
* @returns {Float64Array | undefined}
*/
__exports.segment_direction = function(seg) {
    var ret = wasm.segment_direction(seg);
    return takeObject(ret);
};

/**
* point on line
* @param {number} seg
* @param {number} t
* @returns {number}
*/
__exports.segment_point_on_t_0 = function(seg, t) {
    var ret = wasm.segment_point_on_t_0(seg, t);
    return ret;
};

/**
* point on line
* @param {number} seg
* @param {number} t
* @returns {Float64Array | undefined}
*/
__exports.segment_point_on_t = function(seg, t) {
    var ret = wasm.segment_point_on_t(seg, t);
    return takeObject(ret);
};

/**
* parameter range
* @param {number} seg
* @returns {number}
*/
__exports.segment_get_parameter_range_0 = function(seg) {
    var ret = wasm.segment_get_parameter_range_0(seg);
    return ret;
};

/**
* parameter range
* @param {number} seg
* @returns {Float64Array | undefined}
*/
__exports.segment_get_parameter_range = function(seg) {
    var ret = wasm.segment_get_parameter_range(seg);
    return takeObject(ret);
};

/**
* get point at t
* @param {number} seg
* @returns {number}
*/
__exports.segment_point_on_line_0 = function(seg) {
    var ret = wasm.segment_point_on_line_0(seg);
    return ret;
};

/**
* get point at t
* @param {number} seg
* @returns {Float64Array | undefined}
*/
__exports.segment_point_on_line = function(seg) {
    var ret = wasm.segment_point_on_line(seg);
    return takeObject(ret);
};

/**
* calculate cross point parameter as line 2d
* @param {number} seg_1
* @param {number} seg_2
* @param {number} tolerance
* @returns {number}
*/
__exports.segment_cross_point_parameter_2d_00 = function(seg_1, seg_2, tolerance) {
    var ret = wasm.segment_cross_point_parameter_2d_00(seg_1, seg_2, tolerance);
    return ret;
};

/**
* calculate cross point parameter as line 2d
* @param {number} seg_1
* @param {number} seg_2
* @param {number} tolerance
* @returns {Float64Array | undefined}
*/
__exports.segment_cross_point_parameter_2d_01 = function(seg_1, seg_2, tolerance) {
    var ret = wasm.segment_cross_point_parameter_2d_01(seg_1, seg_2, tolerance);
    return takeObject(ret);
};

/**
* calculate cross point parameter as line 2d
* @param {number} seg_1
* @param {number} seg_2
* @returns {number}
*/
__exports.segment_cross_point_parameter_2d_10 = function(seg_1, seg_2) {
    var ret = wasm.segment_cross_point_parameter_2d_10(seg_1, seg_2);
    return ret;
};

/**
* calculate cross point parameter as line 2d
* @param {number} seg_1
* @param {number} seg_2
* @returns {Float64Array | undefined}
*/
__exports.segment_cross_point_parameter_2d_11 = function(seg_1, seg_2) {
    var ret = wasm.segment_cross_point_parameter_2d_11(seg_1, seg_2);
    return takeObject(ret);
};

/**
* calculate cross point parameter as line 2d
* you will get none if cross point paremeter is out of segment range.
* @param {number} seg_1
* @param {number} seg_2
* @param {number} tolerance
* @returns {number}
*/
__exports.segment_cross_point_parameter_2d_exact_00 = function(seg_1, seg_2, tolerance) {
    var ret = wasm.segment_cross_point_parameter_2d_exact_00(seg_1, seg_2, tolerance);
    return ret;
};

/**
* calculate cross point parameter as line 2d
* you will get none if cross point paremeter is out of segment range.
* @param {number} seg_1
* @param {number} seg_2
* @param {number} tolerance
* @returns {Float64Array | undefined}
*/
__exports.segment_cross_point_parameter_2d_exact_01 = function(seg_1, seg_2, tolerance) {
    var ret = wasm.segment_cross_point_parameter_2d_exact_01(seg_1, seg_2, tolerance);
    return takeObject(ret);
};

/**
* calculate cross point parameter as line 2d
* you will get none if cross point paremeter is out of segment range.
* @param {number} seg_1
* @param {number} seg_2
* @returns {number}
*/
__exports.segment_cross_point_parameter_2d_exact_10 = function(seg_1, seg_2) {
    var ret = wasm.segment_cross_point_parameter_2d_exact_10(seg_1, seg_2);
    return ret;
};

/**
* calculate cross point parameter as line 2d
* you will get none if cross point paremeter is out of segment range.
* @param {number} seg_1
* @param {number} seg_2
* @returns {Float64Array | undefined}
*/
__exports.segment_cross_point_parameter_2d_exact_11 = function(seg_1, seg_2) {
    var ret = wasm.segment_cross_point_parameter_2d_exact_11(seg_1, seg_2);
    return takeObject(ret);
};

/**
* increment reference count
* @param {number} fi
* @returns {number}
*/
__exports.float_indices_retain = function(fi) {
    var ret = wasm.float_indices_retain(fi);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} fi
* @returns {number}
*/
__exports.float_indices_release = function(fi) {
    var ret = wasm.float_indices_release(fi);
    return ret >>> 0;
};

/**
* get all registered float values
* @param {number} fi
* @returns {number}
*/
__exports.float_indices_get_float_keys = function(fi) {
    var ret = wasm.float_indices_get_float_keys(fi);
    return ret;
};

/**
* get indices
* @param {number} fi
* @param {number} float_obj
* @returns {Uint32Array | undefined}
*/
__exports.float_indices_get_indices = function(fi, float_obj) {
    var ret = wasm.float_indices_get_indices(fi, float_obj);
    return takeObject(ret);
};

/**
* instanciate plane
* @param {number} n
* @param {number} c
* @returns {number}
*/
__exports.plane_create_0 = function(n, c) {
    var ret = wasm.plane_create_0(n, c);
    return ret;
};

/**
* @param {number} p1
* @param {number} p2
* @returns {number}
*/
__exports.plane_create_with_2d_0 = function(p1, p2) {
    var ret = wasm.plane_create_with_2d_0(p1, p2);
    return ret;
};

/**
* create plane instance
* @param {Float64Array} n
* @param {Float64Array} c
* @returns {number}
*/
__exports.plane_create = function(n, c) {
    var ret = wasm.plane_create(addHeapObject(n), addHeapObject(c));
    return ret;
};

/**
* create plane instance
* @param {Float64Array} p1
* @param {Float64Array} p2
* @returns {number}
*/
__exports.plane_create_with_2d = function(p1, p2) {
    var ret = wasm.plane_create_with_2d(addHeapObject(p1), addHeapObject(p2));
    return ret;
};

/**
* increment reference count
* @param {number} p
* @returns {number}
*/
__exports.plane_retain = function(p) {
    var ret = wasm.plane_retain(p);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} p
* @returns {number}
*/
__exports.plane_release = function(p) {
    var ret = wasm.plane_release(p);
    return ret >>> 0;
};

/**
* get dimension
* @param {number} p
* @returns {number | undefined}
*/
__exports.plane_get_dimension = function(p) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.plane_get_dimension(retptr, p);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        return r0 === 0 ? undefined : r1 >>> 0;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* calcurate distance
* @param {number} p
* @param {number} v
* @returns {number | undefined}
*/
__exports.plane_distance_0 = function(p, v) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.plane_distance_0(retptr, p, v);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getFloat64Memory0()[retptr / 8 + 1];
        return r0 === 0 ? undefined : r1;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* calcurate distance
* @param {number} p
* @param {Float64Array} v
* @returns {number | undefined}
*/
__exports.plane_distance = function(p, v) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.plane_distance(retptr, p, addHeapObject(v));
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getFloat64Memory0()[retptr / 8 + 1];
        return r0 === 0 ? undefined : r1;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

function getArrayF64FromWasm0(ptr, len) {
    return getFloat64Memory0().subarray(ptr / 8, ptr / 8 + len);
}
/**
* project point to plane
* @param {number} p
* @param {number} v
* @returns {Float64Array | undefined}
*/
__exports.plane_project_0 = function(p, v) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.plane_project_0(retptr, p, v);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        let v0;
        if (r0 !== 0) {
            v0 = getArrayF64FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 8);
        }
        return v0;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* project the point on plane
* @param {number} p
* @param {Float64Array} v
* @returns {Float64Array | undefined}
*/
__exports.plane_project = function(p, v) {
    var ret = wasm.plane_project(p, addHeapObject(v));
    return takeObject(ret);
};

/**
* sort points
* @param {number} p
* @param {number} va
* @returns {number}
*/
__exports.plane_sort_points_0_i = function(p, va) {
    var ret = wasm.plane_sort_points_0_i(p, va);
    return ret;
};

/**
* sort points
* @param {number} p
* @param {any} point_container
* @returns {number}
*/
__exports.plane_sort_points_0 = function(p, point_container) {
    var ret = wasm.plane_sort_points_0(p, addHeapObject(point_container));
    return ret;
};

/**
* sort points
* @param {number} p
* @param {number} va
* @returns {number}
*/
__exports.plane_sort_points_1_i = function(p, va) {
    var ret = wasm.plane_sort_points_1_i(p, va);
    return ret;
};

/**
* sort points
* @param {number} p
* @param {any} point_container
* @returns {number}
*/
__exports.plane_sort_points_1 = function(p, point_container) {
    var ret = wasm.plane_sort_points_1(p, addHeapObject(point_container));
    return ret;
};

/**
* increment reference count
* @param {number} vec
* @returns {number}
*/
__exports.float_vec_retain = function(vec) {
    var ret = wasm.float_vec_retain(vec);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} vec
* @returns {number}
*/
__exports.float_vec_release = function(vec) {
    var ret = wasm.float_vec_release(vec);
    return ret >>> 0;
};

/**
* get count of distanceses
* @param {number} vec
* @returns {number}
*/
__exports.float_vec_size = function(vec) {
    var ret = wasm.float_vec_size(vec);
    return ret >>> 0;
};

/**
* get float object at index
* @param {number} vec
* @param {number} idx
* @returns {number}
*/
__exports.float_vec_get = function(vec, idx) {
    var ret = wasm.float_vec_get(vec, idx);
    return ret;
};

/**
* construct distance
* @param {number} dis
* @returns {number}
*/
__exports.distance_create = function(dis) {
    var ret = wasm.distance_create(dis);
    return ret;
};

/**
* increment reference count
* @param {number} distance
* @returns {number}
*/
__exports.distance_retain = function(distance) {
    var ret = wasm.distance_retain(distance);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} distance
* @returns {number}
*/
__exports.distance_release = function(distance) {
    var ret = wasm.distance_release(distance);
    return ret >>> 0;
};

/**
* get distance value
* @param {number} distance
* @returns {number | undefined}
*/
__exports.distance_get_value = function(distance) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.distance_get_value(retptr, distance);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getFloat64Memory0()[retptr / 8 + 1];
        return r0 === 0 ? undefined : r1;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* get absolute distance value
* @param {number} distance
* @returns {number | undefined}
*/
__exports.distance_get_abs_value = function(distance) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.distance_get_abs_value(retptr, distance);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getFloat64Memory0()[retptr / 8 + 1];
        return r0 === 0 ? undefined : r1;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* create vector
* @param {Float64Array} components
* @returns {number}
*/
__exports.vector_create = function(components) {
    var ret = wasm.vector_create(addHeapObject(components));
    return ret;
};

/**
* get vector components
* @param {number} v
* @returns {Float64Array | undefined}
*/
__exports.vector_get_components = function(v) {
    var ret = wasm.vector_get_components(v);
    return takeObject(ret);
};

/**
* get vector components
* @param {number} v
* @returns {Float32Array | undefined}
*/
__exports.vector_get_components_32 = function(v) {
    var ret = wasm.vector_get_components_32(v);
    return takeObject(ret);
};

/**
* get a component in vector
* @param {number} v
* @param {number} idx
* @returns {number | undefined}
*/
__exports.vector_get_component = function(v, idx) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.vector_get_component(retptr, v, idx);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getFloat64Memory0()[retptr / 8 + 1];
        return r0 === 0 ? undefined : r1;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* increment reference count
* @param {number} v
* @returns {number}
*/
__exports.vector_retain = function(v) {
    var ret = wasm.vector_retain(v);
    return ret >>> 0;
};

/**
* decrement refenrece count
* @param {number} v
* @returns {number}
*/
__exports.vector_release = function(v) {
    var ret = wasm.vector_release(v);
    return ret >>> 0;
};

/**
* vector dimension
* @param {number} v
* @returns {number}
*/
__exports.vector_dimension = function(v) {
    var ret = wasm.vector_dimension(v);
    return ret >>> 0;
};

/**
* increment reference count
* @param {number} di
* @returns {number}
*/
__exports.distance_indices_retain = function(di) {
    var ret = wasm.distance_indices_retain(di);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} di
* @returns {number}
*/
__exports.distance_indices_release = function(di) {
    var ret = wasm.distance_indices_release(di);
    return ret >>> 0;
};

/**
* get all registered distances
* @param {number} di
* @returns {number}
*/
__exports.distance_indices_get_distances = function(di) {
    var ret = wasm.distance_indices_get_distances(di);
    return ret;
};

/**
* get indices
* @param {number} di
* @param {number} distance
* @returns {Uint32Array | undefined}
*/
__exports.distance_indices_get_indices = function(di, distance) {
    var ret = wasm.distance_indices_get_indices(di, distance);
    return takeObject(ret);
};

/**
* move points toward cross line direction with offset
* @param {number} offset
* @param {number} p1
* @param {number} p2
* @param {number} tolerance
* @returns {number}
*/
__exports.geom_d2_offset_points_00 = function(offset, p1, p2, tolerance) {
    var ret = wasm.geom_d2_offset_points_00(offset, p1, p2, tolerance);
    return ret;
};

/**
* move points toward cross line direction with offset
* @param {number} offset
* @param {Float64Array} p1
* @param {Float64Array} p2
* @param {number} tolerance
* @returns {number}
*/
__exports.geom_d2_offset_points_01 = function(offset, p1, p2, tolerance) {
    var ret = wasm.geom_d2_offset_points_01(offset, addHeapObject(p1), addHeapObject(p2), tolerance);
    return ret;
};

/**
* move points toward cross line direction with offset
* @param {number} offset
* @param {Float64Array} p1
* @param {Float64Array} p2
* @param {number} tolerance
* @returns {Array<any> | undefined}
*/
__exports.geom_d2_offset_points_02 = function(offset, p1, p2, tolerance) {
    var ret = wasm.geom_d2_offset_points_02(offset, addHeapObject(p1), addHeapObject(p2), tolerance);
    return takeObject(ret);
};

/**
* move points toward cross line direction with offset
* @param {number} offset
* @param {number} p1
* @param {number} p2
* @returns {number}
*/
__exports.geom_d2_offset_points_10 = function(offset, p1, p2) {
    var ret = wasm.geom_d2_offset_points_10(offset, p1, p2);
    return ret;
};

/**
* move points toward cross line direction with offset
* @param {number} offset
* @param {Float64Array} p1
* @param {Float64Array} p2
* @returns {number}
*/
__exports.geom_d2_offset_points_11 = function(offset, p1, p2) {
    var ret = wasm.geom_d2_offset_points_11(offset, addHeapObject(p1), addHeapObject(p2));
    return ret;
};

/**
* move points toward cross line direction with offset
* @param {number} offset
* @param {Float64Array} p1
* @param {Float64Array} p2
* @returns {Array<any> | undefined}
*/
__exports.geom_d2_offset_points_12 = function(offset, p1, p2) {
    var ret = wasm.geom_d2_offset_points_12(offset, addHeapObject(p1), addHeapObject(p2));
    return takeObject(ret);
};

/**
* move all of points with offset displacement
* @param {number} offset
* @param {number} points
* @param {boolean} close
* @param {number} tolerance
* @returns {number}
*/
__exports.geom_2d_offset_points_vec_00 = function(offset, points, close, tolerance) {
    var ret = wasm.geom_2d_offset_points_vec_00(offset, points, close, tolerance);
    return ret;
};

/**
* move all of points with offset displacement
* @param {number} offset
* @param {Array<any>} points
* @param {boolean} close
* @param {number} tolerance
* @returns {number}
*/
__exports.geom_2d_offset_points_vec_01 = function(offset, points, close, tolerance) {
    var ret = wasm.geom_2d_offset_points_vec_01(offset, addHeapObject(points), close, tolerance);
    return ret;
};

/**
* move all of points with offset displacement
* @param {number} offset
* @param {Array<any>} points
* @param {boolean} close
* @param {number} tolerance
* @returns {Array<any> | undefined}
*/
__exports.geom_2d_offset_points_vec_02 = function(offset, points, close, tolerance) {
    var ret = wasm.geom_2d_offset_points_vec_02(offset, addHeapObject(points), close, tolerance);
    return takeObject(ret);
};

/**
* move all of points with offset displacement
* @param {number} offset
* @param {number} points
* @param {boolean} close
* @returns {number}
*/
__exports.geom_2d_offset_points_vec_10 = function(offset, points, close) {
    var ret = wasm.geom_2d_offset_points_vec_10(offset, points, close);
    return ret;
};

/**
* move all of points with offset displacement
* @param {number} offset
* @param {Array<any>} points
* @param {boolean} close
* @returns {number}
*/
__exports.geom_2d_offset_points_vec_11 = function(offset, points, close) {
    var ret = wasm.geom_2d_offset_points_vec_11(offset, addHeapObject(points), close);
    return ret;
};

/**
* move all of points with offset displacement
* @param {number} offset
* @param {Array<any>} points
* @param {boolean} close
* @returns {Array<any> | undefined}
*/
__exports.geom_2d_offset_points_vec_12 = function(offset, points, close) {
    var ret = wasm.geom_2d_offset_points_vec_12(offset, addHeapObject(points), close);
    return takeObject(ret);
};

/**
* construct distance
* @param {number} value
* @returns {number}
*/
__exports.float_create = function(value) {
    var ret = wasm.float_create(value);
    return ret;
};

/**
* increment reference count
* @param {number} float_obj
* @returns {number}
*/
__exports.float_retain = function(float_obj) {
    var ret = wasm.float_retain(float_obj);
    return ret >>> 0;
};

/**
* decrement reference count
* @param {number} float_obj
* @returns {number}
*/
__exports.float_release = function(float_obj) {
    var ret = wasm.float_release(float_obj);
    return ret >>> 0;
};

/**
* get float value
* @param {number} float_obj
* @returns {number | undefined}
*/
__exports.float_get_value = function(float_obj) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.float_get_value(retptr, float_obj);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getFloat64Memory0()[retptr / 8 + 1];
        return r0 === 0 ? undefined : r1;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* create vectors
* @returns {number}
*/
__exports.vector_array_create = function() {
    var ret = wasm.vector_array_create();
    return ret;
};

/**
* convet vector array from java script array
* @param {Array<any>} array
* @returns {number}
*/
__exports.vector_array_from_js_array = function(array) {
    var ret = wasm.vector_array_from_js_array(addHeapObject(array));
    return ret;
};

/**
* increment reference count
* @param {number} v
* @returns {number}
*/
__exports.vector_array_retain = function(v) {
    var ret = wasm.vector_array_retain(v);
    return ret >>> 0;
};

/**
* increment reference count
* @param {number} v
* @returns {number}
*/
__exports.vector_array_release = function(v) {
    var ret = wasm.vector_array_release(v);
    return ret >>> 0;
};

/**
* get dimension
* @param {number} v
* @returns {number | undefined}
*/
__exports.vector_array_dimension = function(v) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.vector_array_dimension(retptr, v);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        return r0 === 0 ? undefined : r1 >>> 0;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* get size
* @param {number} v
* @returns {number | undefined}
*/
__exports.vector_array_size = function(v) {
    try {
        const retptr = wasm.__wbindgen_export_1.value - 16;
        wasm.__wbindgen_export_1.value = retptr;
        wasm.vector_array_size(retptr, v);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        return r0 === 0 ? undefined : r1 >>> 0;
    } finally {
        wasm.__wbindgen_export_1.value += 16;
    }
};

/**
* add vector
* @param {number} va
* @param {number} v
* @returns {boolean}
*/
__exports.vector_array_add_0 = function(va, v) {
    var ret = wasm.vector_array_add_0(va, v);
    return ret !== 0;
};

/**
* add vector
* @param {number} va
* @param {Float64Array} v
* @returns {boolean}
*/
__exports.vector_array_add_1 = function(va, v) {
    var ret = wasm.vector_array_add_1(va, addHeapObject(v));
    return ret !== 0;
};

/**
* get every components as javasript array
* @param {number} va
* @returns {Array<any> | undefined}
*/
__exports.vector_array_get_components_as_array_array64 = function(va) {
    var ret = wasm.vector_array_get_components_as_array_array64(va);
    return takeObject(ret);
};

/**
* get every components as javasript array
* @param {number} va
* @returns {Array<any> | undefined}
*/
__exports.vector_array_get_components_as_array_array32 = function(va) {
    var ret = wasm.vector_array_get_components_as_array_array32(va);
    return takeObject(ret);
};

async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {

        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {

        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

async function init(input) {
    if (typeof input === 'undefined') {
        let src;
        if (typeof document === 'undefined') {
            src = location.href;
        } else {
            src = document.currentScript.src;
        }
        input = src.replace(/\.js$/, '_bg.wasm');
    }
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = getObject(arg0);
        var ret = typeof(val) === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbg_newwithlength_265b59e73fc01aac = function(arg0) {
        var ret = new Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_get_27693110cb44e852 = function(arg0, arg1) {
        var ret = getObject(arg0)[arg1 >>> 0];
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_47d59fa6a95bb4a5 = function(arg0, arg1, arg2) {
        getObject(arg0)[arg1 >>> 0] = takeObject(arg2);
    };
    imports.wbg.__wbg_from_2a5d647e62275bfd = function(arg0) {
        var ret = Array.from(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_isArray_8719d1387c4e1aca = function(arg0) {
        var ret = Array.isArray(getObject(arg0));
        return ret;
    };
    imports.wbg.__wbg_length_079c4e509ec6d375 = function(arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_newwithlength_8ca2d1860b37aa07 = function(arg0) {
        var ret = new Uint32Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_setindex_c6623b058b2d0617 = function(arg0, arg1, arg2) {
        getObject(arg0)[arg1 >>> 0] = arg2 >>> 0;
    };
    imports.wbg.__wbg_newwithlength_e6bfbd1a5c57733d = function(arg0) {
        var ret = new Float32Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_4306a35ca4194f07 = function(arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_getindex_12564c699da9ab3b = function(arg0, arg1) {
        var ret = getObject(arg0)[arg1 >>> 0];
        return ret;
    };
    imports.wbg.__wbg_setindex_bc95373b06338cd0 = function(arg0, arg1, arg2) {
        getObject(arg0)[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbg_new_0d307f8656ebf4da = function(arg0) {
        var ret = new Float64Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithlength_8c0368c446e0a286 = function(arg0) {
        var ret = new Float64Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_a5ad13d3ed90620f = function(arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_set_01d92d5fbd57fb94 = function(arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_setindex_2c8ef52ef60a2f0e = function(arg0, arg1, arg2) {
        getObject(arg0)[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_buffer_49131c283a06686f = function(arg0) {
        var ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_number_get = function(arg0, arg1) {
        const obj = getObject(arg1);
        var ret = typeof(obj) === 'number' ? obj : undefined;
        getFloat64Memory0()[arg0 / 8 + 1] = isLikeNone(ret) ? 0 : ret;
        getInt32Memory0()[arg0 / 4 + 0] = !isLikeNone(ret);
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function() {
        var ret = wasm.memory;
        return addHeapObject(ret);
    };

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }

    const { instance, module } = await load(await input, imports);

    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;

    return wasm;
}

__exports.init = init;
return __exports;
};
async function startWasm(input) {
    const expMod = createApi({ });
    let wasm = await expMod.init(input);
    expMod.wasm = wasm;
    return expMod;
}
module.exports.init = startWasm;
module.exports.default = module.exports.init;

